export const notificationConstants = {
    NOTIFICATION_PROCESS_START: 'notification:start',
    NOTIFICATION_PROCESS_STOP: 'notification:stop',
    NOTIFICATION_LIST: 'notification:list',
    NOTIFICATION_MORE: 'notification:more',
    NOTIFICATION_READ: 'notification:read',
    NOTIFICATION_REMOVE: 'notification:delete',
    NOTIFICATION_CLEAR: 'notification:clear',
}